import { openBlock as t, createElementBlock as e, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, h = /* @__PURE__ */ l("path", {
  fill: "#D80027",
  d: "M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20L20 0c11.046 0 20 8.954 20 20Z"
}, null, -1), n = /* @__PURE__ */ l("path", {
  fill: "#0052B4",
  d: "M20 20V0C8.954 0 0 8.954 0 20h20Z"
}, null, -1), c = /* @__PURE__ */ l("path", {
  fill: "#F0F0F0",
  d: "m16.02 13.043.323.997h1.048l-.848.616.324.996-.847-.616-.848.616.324-.996-.848-.616h1.048l.324-.996Zm-5.263-7.826.54 1.661h1.746L11.63 7.904l.54 1.661-1.413-1.026-1.412 1.026.54-1.66-1.413-1.027h1.746l.54-1.66Zm5.218 1.739.54 1.661h1.746l-1.413 1.027.54 1.66-1.413-1.026-1.413 1.026.54-1.66-1.413-1.027h1.746l.54-1.66Zm-4.125 6.957.54 1.66h1.746L12.724 16.6l.54 1.66-1.413-1.026-1.413 1.027.54-1.661-1.413-1.026h1.746l.54-1.661ZM7.28 9.565l.539 1.661h1.746l-1.413 1.026.54 1.661-1.413-1.026-1.413 1.026.54-1.66-1.413-1.027H6.74l.54-1.66Z"
}, null, -1), s = [
  h,
  n,
  c
];
function d(i, r) {
  return t(), e("svg", o, [...s]);
}
const a = { render: d };
export {
  a as default,
  d as render
};
